import { defineMessages } from "react-intl"

export default defineMessages({
  likeGame: {
    id: "app.components.GameModal.likeGame",
  },
  finishGame: {
    id: "app.components.GameModal.finishGame",
  },
  howManyHours: {
    id: "app.components.GameModal.howManyHours",
  },
  singlePlayer: {
    id: "app.components.GameModal.singlePlayer",
  },
  multiPlayer: {
    id: "app.components.GameModal.multiPlayer",
  },
  coop: {
    id: "app.components.GameModal.coop",
  },
  "gameExperiences.DidNotPlay": {
    id: "app.components.GameModal.gameExperiences.DidNotPlay",
  },
  "gameExperiences.0to5hours": {
    id: "app.components.GameModal.gameExperiences.0to5hours",
  },
  "gameExperiences.6to10hours": {
    id: "app.components.GameModal.gameExperiences.6to10hours",
  },
  "gameExperiences.11to15hours": {
    id: "app.components.GameModal.gameExperiences.11to15hours",
  },
  "gameExperiences.16to20hours": {
    id: "app.components.GameModal.gameExperiences.16to20hours",
  },
  "gameExperiences.21to30hours": {
    id: "app.components.GameModal.gameExperiences.21to30hours",
  },
  "gameExperiences.31to40hours": {
    id: "app.components.GameModal.gameExperiences.31to40hours",
  },
  "gameExperiences.41to60hours": {
    id: "app.components.GameModal.gameExperiences.41to60hours",
  },
  "gameExperiences.61to100hours": {
    id: "app.components.GameModal.gameExperiences.61to100hours",
  },
  "gameExperiences.101to200hours": {
    id: "app.components.GameModal.gameExperiences.101to200hours",
  },
  "gameExperiences.201to500hours": {
    id: "app.components.GameModal.gameExperiences.201to500hours",
  },
  "gameExperiences.500+hours": {
    id: "app.components.GameModal.gameExperiences.500+hours",
  },
})